import { UseQueryOptions, useQuery } from "@tanstack/react-query";

import { CompanyType } from "@/interfaces/domain/CompanyType";
import { getCompanyTypesRequest } from "@/services/api/companyType";
import { logger } from "@/services/logger";

export const COMPANY_TYPES_QUERY_KEY = "/company-types";

export const useCompanyTypes = (options?: UseQueryOptions<CompanyType[]>) =>
  useQuery<CompanyType[]>({
    queryKey: [COMPANY_TYPES_QUERY_KEY],
    queryFn: () => getCompanyTypesRequest(),
    ...options,
    onError: (error) => {
      logger.error(error);
      options?.onError(error);
    },
  });
